'use client';
import { jsx } from 'react/jsx-runtime';
import { omitThemingProps } from '@chakra-ui/styled-system';
import { TooltipStylesProvider, TooltipContextProvider } from './tooltip-context.mjs';
import { useTooltip } from './use-tooltip.mjs';
import { useStyleConfig } from '../system/use-style-config.mjs';

const TooltipRoot = (props) => {
  const styles = useStyleConfig("Tooltip", props);
  const ownProps = omitThemingProps(props);
  const api = useTooltip(ownProps);
  return /* @__PURE__ */ jsx(TooltipStylesProvider, { value: styles, children: /* @__PURE__ */ jsx(TooltipContextProvider, { value: api, children: props.children }) });
};
TooltipRoot.displayName = "TooltipRoot";

export { TooltipRoot };
